import z from 'zod'
import { AmountSchema } from './price'

const FilterAmountRangeSchema = z.object({
  availableMin: AmountSchema.optional(),
  availableMax: AmountSchema.optional(),
})

export const ResponseShoppingFilterSchema = z.object({
  priceRange: FilterAmountRangeSchema.optional(),
  pointRange: FilterAmountRangeSchema.optional(),
})
